/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_VideoInputs */

const en_val_video = /** @type {(inputs: Val_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const es_val_video = /** @type {(inputs: Val_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const fr_val_video = /** @type {(inputs: Val_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéo`)
};

const de_val_video = /** @type {(inputs: Val_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const ja_val_video = /** @type {(inputs: Val_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオ制作`)
};

const zh_val_video = /** @type {(inputs: Val_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频制作`)
};

const ar_val_video = /** @type {(inputs: Val_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فيديو`)
};

const id_val_video = /** @type {(inputs: Val_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const it_val_video = /** @type {(inputs: Val_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const ru_val_video = /** @type {(inputs: Val_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видео`)
};

const pt_val_video = /** @type {(inputs: Val_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeo`)
};

const ko_val_video = /** @type {(inputs: Val_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비디오 제작`)
};

/**
* | output |
* | --- |
* | "Video" |
*
* @param {Val_VideoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_video = /** @type {((inputs?: Val_VideoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_VideoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_video(inputs)
	if (locale === "es") return es_val_video(inputs)
	if (locale === "fr") return fr_val_video(inputs)
	if (locale === "de") return de_val_video(inputs)
	if (locale === "ja") return ja_val_video(inputs)
	if (locale === "zh") return zh_val_video(inputs)
	if (locale === "ar") return ar_val_video(inputs)
	if (locale === "id") return id_val_video(inputs)
	if (locale === "it") return it_val_video(inputs)
	if (locale === "ru") return ru_val_video(inputs)
	if (locale === "pt") return pt_val_video(inputs)
	return ko_val_video(inputs)
});